import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const bookProofApi = generateProofApi('/proof-file/book');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('book', bookProofApi);

export function getBookProofsByOwnerOptions(bookId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(bookId, userId);
}

export function getBookProofsOptions(bookId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(bookId);
}

export function useUploadOrUpdateBookProof(bookId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(bookId, queryClient));
}

export function useDeleteBookProof(bookId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(bookId, queryClient));
}
